import { useEffect, useState } from 'react'
import { Compass, LayoutGrid } from 'lucide-react'
import { cn } from '@/lib/utils'
import { SidebarDomainNav } from './SidebarDomainNav'
import { SidebarJourneyNav } from './SidebarJourneyNav'

type NavMode = 'domain' | 'journey'

const STORAGE_KEY = 'ispot-sidebar-nav-mode'

interface SidebarProps {
  activeView: string
  onViewChange: (view: string) => void
}

function readStoredMode(): NavMode {
  if (typeof window === 'undefined') return 'domain'
  const v = window.localStorage.getItem(STORAGE_KEY)
  return v === 'journey' || v === 'domain' ? v : 'domain'
}

export function Sidebar({ activeView, onViewChange }: SidebarProps) {
  const [mode, setMode] = useState<NavMode>(readStoredMode)

  useEffect(() => {
    try { window.localStorage.setItem(STORAGE_KEY, mode) } catch { /* ignore */ }
  }, [mode])

  const toggleButton = (
    <button
      type="button"
      onClick={() => setMode(m => (m === 'journey' ? 'domain' : 'journey'))}
      title={mode === 'journey' ? 'Switch to domain view' : 'Switch to journey view'}
      className={cn(
        'flex h-6 w-6 items-center justify-center rounded text-text-muted transition-colors',
        'hover:bg-warm-200/60 hover:text-text'
      )}
    >
      {mode === 'journey' ? (
        <LayoutGrid className="h-3.5 w-3.5" />
      ) : (
        <Compass className="h-3.5 w-3.5" />
      )}
    </button>
  )

  return mode === 'journey' ? (
    <SidebarJourneyNav
      activeView={activeView}
      onViewChange={onViewChange}
      toggleModeButton={toggleButton}
    />
  ) : (
    <SidebarDomainNav
      activeView={activeView}
      onViewChange={onViewChange}
      toggleModeButton={toggleButton}
    />
  )
}
